import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { IFormItem } from '@d-components/dynamic-form/form-base';

@Component({
  template: '',
})
export class CommonBaseComponent {
  @Input() item!: IFormItem;

  @Input() form!: FormGroup;
  @Input() hasLabel: boolean = true;

  get isInValid() {
    const { touched, valid, disabled } = this.form.controls[this.item.key];
    return touched && !valid && !disabled;
  }

  get value() {
    return this.form.controls[this.item.key].value;
  }

  get disabled() {
    return this.form.controls[this.item.key].disabled;
  }

  hasError(type: string) {
    return this.form.controls[this.item.key].hasError(type);
  }
}
